import { Flex } from '@chakra-ui/react';
import { AltTextMenu } from 'modules/Editor/components/Toolbar/AltTextMenu/AltTextMenu';
import { ToolbarDivider } from 'modules/common/components/Toolbar/ToolbarDivider';
import { ReactElement } from 'react';
import { useWidget } from 'widgets/sdk';

import { LineWidgetData } from '../LineWidget.types';
import { LineWidgetToolbarContent } from './LineWidgetToolbarContent';

export const LineWidgetToolbarMenu = (): ReactElement => {
  const { type, strokeColor, strokeWidth, strokeDashType, startArrowStyle, endArrowStyle, updateWidget, widgetId } =
    useWidget<LineWidgetData>();

  return (
    <Flex mr='8px' gap='8px' align='center'>
      <LineWidgetToolbarContent
        values={{
          strokeColor,
          strokeWidth,
          strokeDashType,
          startArrowStyle,
          endArrowStyle,
          type,
        }}
        onUpdate={updateWidget}
      />
      <ToolbarDivider />

      <AltTextMenu widgetId={widgetId} />
    </Flex>
  );
};
